<template>
  <div class="">
    <v-card
      class="py-1 px-2"
      rounded="lg"
    >
      <v-card-text>
        <v-form @submit.prevent="onTrackingContainer">
          <v-row align="center">
            <v-col
              cols="12"
              sm="5"
            >
              <v-text-field
                v-model="containerNo"
                clearable
                :label="$t('label-container-no')"
                type="text"
                prepend-inner-icon="mdi-google-nearby"
                solo
                hide-details
                :loading="isLoading"
                :readonly="isLoading"
                @click:clear="onClearSearch"
              />
            </v-col>
            <v-col
              cols="12"
              sm="5"
            >
              <v-text-field
                v-model="bookingNo"
                clearable
                :label="$t('label-booking-no')"
                type="text"
                prepend-inner-icon="mdi-ticket"
                solo
                hide-details
                :loading="isLoading"
                :readonly="isLoading"
                @click:clear="onClearSearch"
              />
            </v-col>
            <v-col
              cols="12"
              sm="2"
            >
              <v-btn
                class="px-10"
                large
                :class="{
                  'mt-2': $vuetify.breakpoint.mobile,
                }"
                :width="$vuetify.breakpoint.mobile ? '100%' : undefined"
                :disabled="isLoading || !containerNo"
                style="text-transform: none"
                color="info"
                @click="onTrackingContainer"
              >
                <v-icon>mdi-magnify</v-icon>
                {{ $t('search') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>
    <v-scroll-y-transition v-if="!$vuetify.breakpoint.mobile">
      <ContainerTrackingSearchResult
        v-if="render && containerMovements.logs.length > 0"
        class="mt-4 mb-16"
        :loading="isLoading"
      />
    </v-scroll-y-transition>
    <ContainerTrackingSearchResultV2
      v-if="render && containerMovements.logs.length > 0"
      :onTrackingContainer="onTrackingContainer"
      :containerNo="containerNo"
      :bookingNo="bookingNo"
    />
    <v-dialog
      v-if="$vuetify.breakpoint.mobile"
      v-model="dialog.result"
      fullscreen
      transition="dialog-bottom-transition"
      scrollable
    >
      <MobileContainerTrackingSearchResult
        v-if="dialog.result && containerMovements.logs.length > 0"
        @close-dialog="dialog.result = false"
      />
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';
import ContainerTrackingSearchResult from './ContainerTrackingSearchResult.vue';
import MobileContainerTrackingSearchResult from './MobileContainerTrackingSearchResult.vue';
import ContainerTrackingSearchResultV2 from './ContainerTrackingSearchResultV2.vue';

export default {
  components: {
    ContainerTrackingSearchResultV2,
    ContainerTrackingSearchResult,
    MobileContainerTrackingSearchResult,
  },
  data: () => ({
    isLoading: false,
    containerNo: '',
    bookingNo: '',
    dialog: {
      result: false,
    },
    render: false,
  }),
  computed: {
    ...mapState('vsl/containerTracking', ['containerMovements']),
  },
  created() {
    const { container_no, booking_no } = this.$route.query;
    this.containerNo = container_no || '';
    this.bookingNo = booking_no || '';
    if (this.containerNo) {
      this.onTrackingContainer();
    }
  },
  destroyed() {
    this.RESET();
  },
  methods: {
    ...mapMutations('vsl/containerTracking', ['RESET']),
    ...mapActions('vsl/containerTracking', ['fetchContainerTrackingInfo']),
    async onTrackingContainer() {
      if (!this.containerNo) {
        await this.$router.push({ query: {} }).catch(() => {});
        return;
      }
      try {
        this.isLoading = true;
        await this.$router
          .push({
            query: {
              container_no: this.containerNo,
              booking_no: this.bookingNo || undefined,
            },
          })
          .catch(() => {});
        await this.fetchContainerTrackingInfo({
          containerNo: this.containerNo,
          bookingNo: this.bookingNo || undefined,
        });
        this.render = false;
        await new Promise((resolve) => setTimeout(resolve, 100));
        this.render = true;
        if (this.$vuetify.breakpoint.mobile) {
          this.dialog.result = true;
        }
      } catch (error) {
        console.error('Error fetching container tracking:', error);
        // Có thể thêm thông báo lỗi cho người dùng
        this.$toast.error(this.$t('error-fetching-tracking'));
      } finally {
        this.isLoading = false;
      }
    },
    async onClearSearch() {
      this.containerNo = '';
      this.bookingNo = '';
      await this.$router.push({ query: {} }).catch(() => {});
    },
  },
};
</script>

<style></style>
